// Check if URL contains HTTP, then redirect to HTTPs
// import httpsProtocol from './httpsProtocol.js';$2y$10$k1movcKOvndjTSwxW3FGQekpK…

// ## essintial for the theme
import './assets/sass/app.scss';

import _ from 'lodash';
import $ from 'jquery';
window._ = _;
window.$ = $;
require('bootstrap');
require('./assets/js/admin.js');

import './assets/js/fontawesome.js';

import Vue from 'vue'
import './assets/new-css/global.css'

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel);
Vue.component('pagination', require('laravel-vue-pagination'));

//switch toggler
import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

// Bootstarp-Vue
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// for jquery
window.$ = window.jQuery = require('jquery')
var Editor = require('@tinymce/tinymce-vue').default;
// ## importing JS
window.Vue = Vue;
require('dotenv').config();

import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);
// api configurations
// Vue.prototype.$baseURL = 'https://devapi.linentech.net';
Vue.prototype.$baseURL = process.env.VUE_APP_API_URL;
Vue.prototype.$adminPannelUrl = process.env.VUE_APP_LINENTECH_V3;
Vue.axios.defaults.baseURL = Vue.prototype.$baseURL + '/api';
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
Vue.prototype.$tinymceApi = process.env.VUE_APP_TINYMCE_EDITOR_API_KEY;
// router and store
import router from './router.js';
Vue.router = router;
import store from './store';



// vuetify

import vuetify from '@/plugins/vuetify' // path to vuetify export

// vue-toastificastion
import toast from '@/plugins/toast' // path to vuetify export


// vue-auth and Gate

Vue.use(require('@websanova/vue-auth'), {
    auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),

    tokenDefaultName: 'access_token',
    tokenStore: ['localStorage'],
    authRedirect: { path: '/login' },
    notFoundRedirect: { path: '/404' },
    rolesVar: 'role',
    refreshData: {
        enabled: false, interval: 0
    },
    fetchData: {
        url: '/auth/admin-user',
        method: 'GET',
    },

    parseUserData: function (data) {
        return data.user;
    }
});

import Gate from './gate';
Vue.prototype.$gate = new Gate();


// import global components
import Paginate from 'vuejs-paginate';
Vue.component('paginate', Paginate);

import Breabcrumbs from 'vue-2-breadcrumbs';
Vue.use(Breabcrumbs);


// event bus
const EventBus = new Vue();
Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function () {
            return EventBus;
        }
    }
});

axios.interceptors.request.use(config => {
    config.headers.organization = store.getters['users/organizationId'];

    return config;
});

function can(permission) {
    let uprms = JSON.parse(localStorage.getItem('user_permissions'));
    return  (permission in  uprms);
  }
  Vue.prototype.$can = can;
// Vue instance
import EntryPoint from './EntryPoint';

new Vue({
    el: '#app',
    router,
    store,
    app,
    vuetify,
    toast,
    render: h => h(EntryPoint)
});


// new Vue({
//   el: '#app_loader',

// });
